import CustomSideBar from "../customSideBar/customSideBar";
import styles from "./header.module.scss";

export default function Header() {
  return (
    <div className={styles.mainContainer}>
      <CustomSideBar />
    </div>
  );
}
